/**
 * Google Analytics 4 Event Names
 * @description Standard GA4 event names used across the application
 */
export enum GA4EventNameEnum {
  // Page View Events
  PAGE_VIEW = 'page_view',

  // User Interaction Events
  BUTTON_CLICK = 'button_click',
  LINK_CLICK = 'link_click',
  FORM_SUBMIT = 'form_submit',

  // E-commerce Events
  VIEW_ITEM = 'view_item',
  ADD_TO_CART = 'add_to_cart',
  BEGIN_CHECKOUT = 'begin_checkout',
  PURCHASE = 'purchase',

  // Booking Events
  BOOKING_STARTED = 'booking_started',
  BOOKING_COMPLETED = 'booking_completed',
  BOOKING_CANCELLED = 'booking_cancelled',

  // User Events
  LOGIN = 'login',
  SIGN_UP = 'sign_up',

  // Custom Events
  REPORT_VIEWED = 'report_viewed',
  CHECK_IN_COMPLETED = 'check_in_completed',
  PROMO_CODE_APPLIED = 'promo_code_applied',
}

/**
 * Google Analytics 4 Parameter Names
 * @description Standard parameter names for GA4 events
 */
export enum GA4ParameterNameEnum {
  // Content Parameters
  CONTENT_CATEGORY = 'content_category',
  CONTENT_TYPE = 'content_type',

  // User Parameters
  USER_TYPE = 'user_type',
  USER_ID = 'user_id',

  // Page Parameters
  PAGE_TITLE = 'page_title',
  PAGE_PATH = 'page_path',

  // Event Parameters
  EVENT_ID = 'event_id',
  EVENT_NAME = 'event_name',

  // E-commerce Parameters
  CURRENCY = 'currency',
  VALUE = 'value',
  TRANSACTION_ID = 'transaction_id',

  // Booking Parameters
  CLUB_NAME = 'club_name',
  ORDER_ID = 'order_id',

  // Timestamp
  TIMESTAMP = 'timestamp',
}

/**
 * User Type Constants
 * @description Types of users in the application
 */
export enum UserTypeEnum {
  ADMIN = 'admin',
  OPERATOR = 'operator',
  CUSTOMER = 'customer',
  ANONYMOUS = 'anonymous',
}

/**
 * Content Category Constants
 * @description Content categories for page tracking
 */
export enum ContentCategoryEnum {
  REPORTS = 'reports',
  CHECK_IN = 'check-in',
  BOOKING = 'booking',
  CHECKOUT = 'checkout',
  CONFIRMATION = 'confirmation',
  DASHBOARD = 'dashboard',
  PROFILE = 'profile',
  SETTINGS = 'settings',
}
